export default function getRightValue(newValue, oldValue) {
  return !newValue && newValue !== 0 ? oldValue : newValue;
}



// WEBPACK FOOTER //
// ./src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/components/ColorPicker/helpers/getRightValue.js